/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import type { AppStorage } from '../../helpers/storages';
import type { AppDataStore } from '../../stores/app-data';
import type { AddonContext } from './interfaces';
import type { AppServices, BaseLang } from '../../interfaces';

export class BaseAddon {

    protected readonly suppliers: Record<string, any>;
    protected readonly services: AppServices;
    protected readonly lang: BaseLang;
    protected readonly appDataStore: AppDataStore;
    protected readonly appStorage: AppStorage;
    protected readonly noAuth: boolean;
    protected readonly initOrderNumber: number;

    constructor(addonContext: AddonContext) {
        const { suppliers, services, lang, appDataStore, appStorage, noAuth, initOrderNumber } = addonContext;

        this.suppliers = suppliers;
        this.services = services;
        this.lang = lang;
        this.appDataStore = appDataStore;
        this.appStorage = appStorage;
        this.noAuth = noAuth;
        this.initOrderNumber = initOrderNumber ?? 0;
    }

    init(): Promise<void> | void {
        /* Can be overrided in plugin */
        throw Error('Required');
        return Promise.resolve();
    }

    destroy(): void {
        /* Can be overrided in plugin */
        throw Error('Required');
    }

    getInitOrderNumber(): number {
        return this.initOrderNumber;
    }

}
